import { render } from "./Tutors.vue?vue&type=template&id=ff494768&scoped=true&bindings={}"
import script from "./Tutors.vue?vue&type=script&lang=ts"
export * from "./Tutors.vue?vue&type=script&lang=ts"

import "./Tutors.vue?vue&type=style&index=0&id=ff494768&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ff494768"

export default script